import * as K from './UsersConstants';
import Fuse from 'fuse.js';
import floopback from 'lib/floopback';
import axios from 'axios';

var users = new floopback('users');

export function find(params) {
  return async (dispatch, getState) => {
    var _this = this;
    const query = await axios.get(
      process.env.REACT_APP_URL_API +
        '/api/users?filter=' +
        JSON.stringify(params)
    );

    dispatch({
      type: K.FIND + '_FULFILLED',
      payload: query.data,
    });

    _this.searchTable(getState().Users.search);
  };
}

export function findById(id, params) {
  return (dispatch, getState) => {
    dispatch({
      type: K.FIND_BY_ID,
      payload: users.findById(id, params),
    });
  };
}

export function create(formData) {
  return (dispatch, getState) => {
    return new Promise(function (resolve, reject) {
      dispatch({ type: K.CREATE + '_PENDING', payload: formData });
      users
        .create(formData)
        .then(function (data) {
          dispatch({ type: K.CREATE + '_FULFILLED', payload: data });
          resolve(data);
        })
        .catch(function (error) {
          console.log('error error error', error);
          dispatch({ type: K.CREATE + '_REJECTED', payload: error });
          reject(error);
        });
    });
  };
}

export function update(id, formData) {
  return (dispatch, getState) => {
    return new Promise(function (resolve, reject) {
      dispatch({ type: K.UPDATE + '_PENDING', payload: formData });
      users
        .update(id, formData)
        .then(function (data) {
          dispatch({ type: K.UPDATE + '_FULFILLED', payload: data });
          resolve(data);
        })
        .catch(function (error) {
          dispatch({ type: K.UPDATE + '_REJECTED', payload: error });
          reject(error);
        });
    });
  };
}

export function remove(id) {
  return (dispatch, getState) => {
    return new Promise(function (resolve, reject) {
      dispatch({ type: K.DELETE + '_PENDING' });
      users
        .delete(id)
        .then(function (data) {
          dispatch({ type: K.DELETE + '_FULFILLED', payload: data });
          resolve(data);
        })
        .catch(function (error) {
          dispatch({ type: K.DELETE + '_REJECTED', payload: error });
          reject(error);
        });
    });
  };
}

export function changeTable(feature, value) {
  return (dispatch, getState) => {
    dispatch({
      type: K.CHANGE_TABLE,
      payload: {
        feature: feature,
        value: value,
      },
    });
  };
}

export function searchTable(search) {
  return (dispatch, getState) => {
    var options = {
      threshold: 0.4,
      location: 0,
      distance: 100,
      maxPatternLength: 32,
      minMatchCharLength: 1,
      keys: ['firstName', 'lastName', 'email'],
    };

    var fuse = new Fuse(getState().Users.data, options);
    let result = fuse.search(search);

    dispatch({
      type: K.SEARCH_TABLE,
      payload: {
        search: search,
        searchData: result,
      },
    });
  };
}



// WEBPACK FOOTER //
// ./src/views/Users/redux/UsersActions.js